var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconButtonX = function SvgIconButtonX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-button-x",
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "circle_button",
    "data-name": "circle button"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle_button-2",
    "data-name": "circle button",
    cx: 18,
    cy: 18,
    r: 18,
    fill: "rgba(255,255,255,0)",
    stroke: "#f2f2f2",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M714.2 519.3 1160.9 0H1055L667.1 450.9 357.3 0H0l468.5 681.8L0 1226.4h105.9l409.6-476.2 327.2 476.2H1200L714.2 519.3zm-145 168.5-47.5-67.9L144 79.7h162.6l304.8 436 47.5 67.9 396.2 566.7H892.5L569.2 687.8z",
    transform: "matrix(.01 0 0 .01 12 12)",
    id: "icon-x"
  }))));
};
export { SvgIconButtonX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzNyIgaGVpZ2h0PSIzNyIgdmlld0JveD0iMCAwIDM3IDM3Ij4KICA8ZyBpZD0iaWNvbi1idXR0b24teCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC41IDAuNSkiPgogICAgPGcgaWQ9ImNpcmNsZV9idXR0b24iIGRhdGEtbmFtZT0iY2lyY2xlIGJ1dHRvbiI+CiAgICAgIDxjaXJjbGUgaWQ9ImNpcmNsZV9idXR0b24tMiIgZGF0YS1uYW1lPSJjaXJjbGUgYnV0dG9uIiBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMCkiIHN0cm9rZT0iI2YyZjJmMiIgc3Ryb2tlLXdpZHRoPSIxIi8+CiAgICA8L2c+CiAgICA8ZyBpZD0iaWNvbi14IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMiAxMikgc2NhbGUoMC4wMTAwKSI+CiAgICAgIDxwYXRoIGQ9Ik03MTQuMiw1MTkuM0wxMTYwLjksMEgxMDU1TDY2Ny4xLDQ1MC45TDM1Ny4zLDBIMGw0NjguNSw2ODEuOEwwLDEyMjYuNGgxMDUuOWw0MDkuNi00NzYuMmwzMjcuMiw0NzYuMkgxMjAwTDcxNC4yLDUxOS4zCglMNzE0LjIsNTE5LjN6IE01NjkuMiw2ODcuOGwtNDcuNS02Ny45TDE0NCw3OS43aDE2Mi42bDMwNC44LDQzNmw0Ny41LDY3LjlsMzk2LjIsNTY2LjdIODkyLjVMNTY5LjIsNjg3LjhMNTY5LjIsNjg3Ljh6Ii8+CgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";